import React, { useRef, useMemo, useEffect } from 'react';
import Header from './Header/Header.js';
import Row from './Row/Row.js';
import { columnDepth, isColumnGroup } from '../../../atom/util/table.js';
import { twMerge } from 'tailwind-merge';
import { clsx } from 'clsx';
import '../../../tailwind.css.js';

var keyOf = function (itemKey, item) {
    var key = typeof itemKey === 'function' ? itemKey(item) : item[itemKey];
    return typeof key === 'number' ? key : String(key);
};
var flattenColumns = function (columns) { return columns.flatMap(function (column) {
    return !isColumnGroup(column) ? [column] : flattenColumns(column.columns);
}); };
var BaseTable = function (props) {
    var columns = flattenColumns(props.columns);
    var depth = props.depth || columnDepth(props.columns);
    var header = React.createElement(Header, { columns: props.columns, toggleSort: props.toggleSort, dividers: props.dividers, depth: depth });
    var tableLoaderRowRef = useRef(null);
    var rows = props.items.map(function (item) { return React.createElement(Row, { key: keyOf(props.itemKey, item), item: item, columns: columns, expansion: props.expansion, autoExpand: props.autoExpand, dividers: props.dividers, loading: props.loading && !props.infinite }); });
    while (props.size && rows.length < props.size) {
        rows.push(React.createElement(Row, { key: rows.length, item: null, columns: columns, loading: props.loading && !props.infinite }));
    }
    var height = useMemo(function () {
        if (props.size) {
            return 48 * props.size;
        }
        else if (props.empty) {
            return 'fit-content';
        }
        return 0;
    }, [props.size, props.empty]);
    useEffect(function () {
        if (!tableLoaderRowRef.current || props.items.length === 0)
            return;
        var observer = new IntersectionObserver(function (entries) {
            var _a;
            var entry = entries[0];
            if (entry.isIntersecting) {
                (_a = props.onRowsScrollEnd) === null || _a === void 0 ? void 0 : _a.call(props);
            }
        });
        observer.observe(tableLoaderRowRef.current);
        return function () {
            if (tableLoaderRowRef.current) {
                observer.unobserve(tableLoaderRowRef.current);
            }
        };
    }, [tableLoaderRowRef.current, props.items]);
    var content = rows.length ? rows : (React.createElement("tr", { style: { height: height } },
        React.createElement("td", { colSpan: columns.length, align: "center", className: "h-[inherit] p-0" }, props.empty)));
    return (React.createElement("table", { id: props.id, className: twMerge(clsx(props.className)) },
        React.createElement("thead", null, header),
        React.createElement("tbody", null,
            content,
            props.infinite && props.items.length > 0 && React.createElement(Row, { ref: tableLoaderRowRef, item: {}, columns: columns, loading: props.loading && props.infinite }))));
};

export { BaseTable as default };
